module.exports = __webpack_public_path__ + "img/ghmghm@2x.e058f115.png";